import React from 'react';
import { CheckIcon } from 'lucide-react';
import type { SessionModule } from '../types/content';
export function ModuleSection({
  module
}: {
  module: SessionModule;
}) {
  const titleId = `modulo-${module.number}-title`;
  return <article id={`modulo-${module.number}`} className="grid gap-x-10 gap-y-5 rounded-[2rem] bg-white p-6 ring-1 ring-cream-line sm:p-8 md:grid-cols-[230px_1fr] md:items-center" aria-labelledby={titleId} data-id="element-136" data-mp="1691y5mve4jo1">
      <header className="md:col-start-2 md:row-start-1 md:self-end" data-id="element-137" data-mp="whxhmiq2gqr3">
        <span className="inline-flex rounded-full bg-petrol px-3.5 py-1.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-paper" data-id="element-138" data-mp="11bieu8ju5gp8">
          Módulo {module.number}
        </span>
        <h3 id={titleId} className="mt-3 font-display text-3xl leading-tight text-petrol sm:text-[2rem]" data-id="element-139" data-mp="rlyv70oatitb">
          {module.title}
        </h3>
      </header>

      <div className="mx-auto w-full max-w-[240px] md:col-start-1 md:row-span-2 md:row-start-1 md:max-w-none" data-id="element-140" data-mp="ik94jx28qnwl">
        <img src={module.coverImage} alt={`Portada del Módulo ${module.number}: ${module.title}`} width={module.coverWidth} height={module.coverHeight} loading="lazy" className="block h-auto w-full" data-id="element-141" data-mp="308jytgs12uxm" />
      </div>

      <div className="md:col-start-2 md:row-start-2 md:self-start" data-id="element-142" data-mp="34anc8ay9c9lj">
        <p className="leading-relaxed text-ink" data-id="element-143" data-mp="34bg9mlbbtmr0">{module.description}</p>
        <ul className="mt-4 grid gap-x-6 gap-y-1.5 sm:grid-cols-2" data-id="element-144" data-mp="2gm43jubapusx">
          {module.resources.map(r => <li key={r} className="flex items-start gap-2 text-[15px] text-ink-soft" data-id="element-145" data-mp="2cksdxosf99kq">
              <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-sage-deep" strokeWidth={2.4} aria-hidden="true" data-id="element-146" data-mp="2qbxcsonytxu0" />
              {r}
            </li>)}
        </ul>
        <p className="mt-5 border-l-2 border-terra pl-4 font-display text-lg italic leading-snug text-terra-deep" data-id="element-147" data-mp="1xub87t8r7xi1">{module.tagline}</p>
      </div>
    </article>;
}